import { render } from "./Nav.vue?vue&type=template&id=bb787310&ts=true"
import script from "./Nav.vue?vue&type=script&lang=ts"
export * from "./Nav.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\dev\\laragon\\www\\test-interactiv\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__